import {Component, ElementRef, Input} from '@angular/core';

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}

@Component({
  selector: 'sort-arrow',
  template: `<img src="data:image/svg+xml;base64,PHN2ZyBpZD0iTGl2ZWxsb18xIiBkYXRhLW5hbWU9IkxpdmVsbG8gMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM3NTc1NzU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5zb3J0LWFycm93PC90aXRsZT48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTEuMTIgNS4xMyA1Ljk5IDAgMC44OCA1LjExIDIuMjkgNi41MyA1IDMuODIgNSAxMiA3IDEyIDcgMy44NCA5LjcxIDYuNTQgMTEuMTIgNS4xMyIvPjwvc3ZnPg==">`,
  styles: [`
    :host {
      user-select: none;
    }
    
    img {
      width: 12px;
      height: 12px;
      opacity: 0;
      transform: translateY(8px) rotateX(0);
      will-change: transform;
      transition: all .3s ease;
    }
    
    :host.hover img,
    :host.asc img {
      opacity: 1;
      transform: translateY(0);
    }

    :host.desc img {
      opacity: 1;
      transform: rotateX(180deg);
    }
  `],
})
export class SortArrowComponent {

  constructor(public el: ElementRef) {}

}
